import { type BadgeStatus, StatusBadge } from "@/components/ui/status-badge";
import { STATUS_LABELS, type SupportIssueStatus } from "@/lib/support-issue-labels";

const TONE: Record<SupportIssueStatus, BadgeStatus> = {
  open: "info",
  in_progress: "brand",
  in_review: "brand",
  blocked: "failed",
  resolved: "completed",
  closed: "disabled",
};

/** An Issue's status — the one status colour on a row. */
export function IssueStatusBadge({ status }: { status: SupportIssueStatus }) {
  return <StatusBadge status={TONE[status]}>{STATUS_LABELS[status]}</StatusBadge>;
}
